'use client';
/* eslint-disable */

import {
   Box,
   Button,
   Flex,
   Text,
   useColorModeValue,
   useDisclosure,
   Select,
   Switch,
   Grid,
   useOutsideClick,
   useBreakpointValue,
   useColorMode,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalCloseButton,
   ModalBody,
   SimpleGrid,
   ModalFooter,
   IconButton,
} from '@chakra-ui/react';
import { DeleteIcon, EditIcon } from '@chakra-ui/icons';
import {
   createColumnHelper,
   flexRender,
   getCoreRowModel,
   getSortedRowModel,
   useReactTable,
} from '@tanstack/react-table';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
// import autoTable from 'jspdf-autotable';
import React, { useEffect, useState, useRef } from 'react';
import Card from 'components/card/Card';
import Menu from 'components/menu/MainMenu';
import { SearchBar } from 'components/navbar/searchBar/SearchBar';
import VendorMasterForm from './VendorMasterForm';
import ViewSingleData from '../../../masters/components/ViewSingleData';
import { useDispatch, useSelector } from 'react-redux';
import { MdNavigateNext, MdNavigateBefore } from 'react-icons/md';
import {
   getVendors,
   addVendor,
   deleteVendor,
   updateStatus,
   getSingleVendors,
} from '../../../../../redux/actions/vendor';
import DeleteDialog from '../../components/DeleteDialog';
import AddEditForm from '../CustomerMaster/AddEditForm';
import { ACCOUNT_TYPE } from '../../../../../constants/index';
import { useUser } from '../../../../../contexts';
import MobileDataTable from '../../components/MobileDataTable';
// filter
import filter from 'assets/img/nfts/filter.svg';
import filter1 from 'assets/img/nfts/filter1.svg';
import nodata from 'assets/img/nfts/no data.svg';
import { GridItem, Input, FormLabel } from '@chakra-ui/react';
import {
   getAccount,
   getAccountForMaster,
   multiDeleteCustomer,
   // multiDeleteCustomer
} from '../../../../../redux/actions/account';
import DynamicTable from '../../components/DynamicAllDataTable';
import { SearchIcon } from '@chakra-ui/icons';
import { motion } from 'framer-motion';
import { getReportLedger, getReportOutstandingDetail } from '../../../../../redux/actions/reports';
import { useGlobal } from '../../../../../contexts';
import { postColumnsHideShow } from '../../../../../redux/actions/utility';
import { BsEye } from 'react-icons/bs';
import { X } from 'lucide-react';
import Loader from 'views/admin/default/Loader';
//filter end

const columnHelper = createColumnHelper();
const MotionFlex = motion(Flex);
const MotionSearchIcon = motion(SearchIcon);

export default function VendorMaster({ tableData }) {
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const [sorting, setSorting] = React.useState([]);
   const dispatch = useDispatch();
   const userData = useSelector((state) => state?.account?.listForMaster || []);
   const singleEntity = useSelector((state) => state?.vendor?.single || {});
   const Ledger = useSelector((state) => state.reports.ledger || []);
   const OS = useSelector((state) => state.reports.outstanding || []);
   const pagination = useSelector((state) => state.account?.paginationForMaster);
   const [data, setData] = React.useState([...userData]);
   const [sortedUserData, setSortedUserData] = useState([]);
   const { user } = useUser();
   const Admin = user?.isAdmin;
   // const [currentRow, setCurrentRow] = React.useState(null);
   const [currentRow, setCurrentRow] = React.useState({});
   const isAbs = currentRow?.isAbs === 'true' || currentRow?.isAbs === true;
   const isMobileOrTablet = useBreakpointValue({ base: true, md: false, lg: false });
   const [focusedInput, setFocusedInput] = React.useState(null);
   const [pageSize, setPageSize] = React.useState(10);
   const [isDeleteDialogOpen, setDeleteDialogOpen] = React.useState(false); // State to manage delete confirmation
   const [selectedRowId, setSelectedRowId] = React.useState(null);
   const [searchQuery, setSearchQuery] = React.useState('');
   const [debouncedSearchQuery, setDebouncedSearchQuery] = React.useState('');
   const [isOpenSingleView, setIsOpenSingleView] = React.useState(false);
   const bg = useColorModeValue('#f2f7f2', '#1a254b');
   const icon = useColorModeValue('#000000', '#ffffff');
   const companyId = Number(localStorage.getItem('companyId'));
   const [isEditingPage, setIsEditingPage] = useState(false);
   const [pageInputValue, setPageInputValue] = useState('');
   const vendorRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === companyId)?.vendor
      : null;
   const singleEntityWithLedger = {
      ...singleEntity,
      ledger: Ledger,
      os: OS,
   };
   const { userGlobalSettingsData } = useGlobal();
   const globalSetting = userGlobalSettingsData?.[0]?.askCompany?.account;
   const shouldShowCompanyDropdown = globalSetting || false;
   const [currentPage, setCurrentPage] = useState(1);
   const [limit, setLimit] = useState(10);
   const isDesktop = useBreakpointValue({ base: false, md: true });
   const [isLoading, setIsLoading] = useState(false);
   const [isSearching, setIsSearching] = useState(false);
   const [columnsData, setColumnsData] = React.useState([
      {
         id: 'name',
         header: 'NAME',
         accessor: 'name',
      },
      {
         id: 'mobile',
         header: 'MOBILE',
         accessor: 'mobile',
      },
      {
         id: 'panNo',
         header: 'PAN',
         accessor: 'panNo',
      },
      {
         id: 'email',
         header: 'EMAIL',
         accessor: 'email',
      },
      {
         id: 'gstRegNo',
         header: 'GST',
         accessor: 'gstRegNo',
      },
      {
         id: 'createdAt',
         header: 'CREATED DATE',
         accessor: 'createdAt',
         cell: (info) => moment(info.getValue()).format('DD-MM-YYYY'),
      },
      {
         id: 'address1',
         header: 'ADDRESS',
         accessor: 'address1',
      },
      {
         id: 'city',
         header: 'CITY',
         accessor: (row) => {
            const billingAddress = row.accountaddress.find((addr) => addr.name === 'billing');
            return billingAddress ? billingAddress.city : '';
         },
      },
      {
         id: 'state',
         header: 'STATE',
         accessor: (row) => {
            const billingAddress = row.accountaddress.find((addr) => addr.name === 'billing');
            return billingAddress ? billingAddress.state : '';
         },
      },
      {
         id: 'country',
         header: 'COUNTRY',
         accessor: (row) => {
            const billingAddress = row.accountaddress.find((addr) => addr.name === 'billing');
            return billingAddress ? billingAddress.country : '';
         },
      },

      {
         id: 'pincode',
         header: 'PINCODE',
         accessor: (row) => {
            const billingAddress = row.accountaddress.find((addr) => addr.name === 'billing');
            return billingAddress ? billingAddress.pincode : '';
         },
      },
      {
         id: 'ledger',
         header: 'LEDGER',
         accessor: 'ledger',
      },
      {
         id: 'amt',
         header: 'BALANCE',
         accessor: 'amt',
      },
      {
         id: 'status',
         header: 'STATUS',
         accessor: 'status',
         cell: (info) => {
            return <span>{info.getValue()}</span>;
         },
      },
   ]);

   const [columnVisibility, setColumnVisibility] = React.useState({
      name: true,
      address: false,
      city: false,
      state: false,
      country: false,
      pincode: false,
      mobile: true,
      panNo: false,
      email: false,
      gstRegNo: true,
      createdAt: false,
      glgroupname: true,
      amt: true,
      status: true,
   });

   const [isColumnModalOpen, setIsColumnModalOpen] = useState(false);

   useEffect(() => {
      if (user?.viewJson) {
         const companySettings = user.viewJson.find((item) => item.companyId === companyId);
         if (companySettings?.account) {
            // Only update if there's an actual change to prevent unnecessary re-renders
            setColumnVisibility((prev) => {
               const newVisibility = companySettings.account;
               // Compare objects to avoid unnecessary state updates
               return JSON.stringify(prev) === JSON.stringify(newVisibility) ? prev : newVisibility;
            });
         }
      }
   }, [user, companyId, user?.viewJson]);

   useEffect(() => {
      if (userData && userData.length > 0) {
         const sortBy = sorting.length ? sorting[0]?.id : 'name';
         const sortOrder = sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'asc';

         const sortedData = [...userData].sort((a, b) => {
            const valueA = a[sortBy]?.toString().toLowerCase() || '';
            const valueB = b[sortBy]?.toString().toLowerCase() || '';

            if (sortOrder === 'asc') {
               return valueA.localeCompare(valueB);
            } else {
               return valueB.localeCompare(valueA);
            }
         });

         setSortedUserData(sortedData);
      } else {
         setSortedUserData([]);
      }
   }, [userData, sorting]);

   const filteredData = React.useMemo(() => {
      if (!searchQuery) return data;
      return data?.filter((row) =>
         columnsData?.some((col) => String(row[col.id]).toLowerCase().includes(searchQuery.toLowerCase())),
      );
   }, [data, searchQuery, columnsData]);

   useEffect(() => {
      setCurrentPage(1); // Reset to page 1 whenever searchQuery changes
   }, [debouncedSearchQuery]);

   const debounce = (func, delay) => {
      let timer;
      return function (...args) {
         clearTimeout(timer);
         timer = setTimeout(() => func.apply(this, args), delay);
      };
   };
   const debouncedSearchHandler = React.useCallback(
      debounce((query) => {
         setDebouncedSearchQuery(query);
         setIsSearching(false);
      }, 500),
      [],
   );

   // Handle search input changes
   const handleSearchChange = (e) => {
      const value = e.target.value.trimStart();
      setSearchQuery(value);
      setIsSearching(true);
      debouncedSearchHandler(value);
   };

   useEffect(() => {
      const fetchMainData = async () => {
         try {
            setIsLoading(true);
            await dispatch(
               getAccountForMaster({
                  type: 'E',
                  page: currentPage,
                  search: debouncedSearchQuery,
                  sortBy: sorting.length ? sorting[0]?.name : 'name',
                  sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'asc',
                  compId: user?.loginhistory?.companyId,
                  ...(shouldShowCompanyDropdown && { companyIds: user?.loginhistory?.companyId }),
               }),
            );
         } catch (error) {
            console.error('Error fetching main data:', error);
         } finally {
            setIsLoading(false);
         }
      };

      fetchMainData();
   }, [
      debouncedSearchQuery,
      currentPage,
      limit,
      sorting,
      dispatch,
      user?.loginhistory?.companyId,
      shouldShowCompanyDropdown,
   ]);

   const handlePageChange = (directionOrPage) => {
      if (typeof directionOrPage === 'number') {
         // Direct page number navigation
         setCurrentPage(directionOrPage);
      } else {
         // Previous/next navigation
         const newPage = directionOrPage === 'next' ? pagination.nextPage : pagination.previousPage;
         if (newPage) setCurrentPage(newPage);
      }
   };

   const handlePageClick = () => {
      setIsEditingPage(true);
      setPageInputValue(''); // Clear input value when starting to edit
   };

   const handlePageInputSubmit = () => {
      const page = parseInt(pageInputValue);
      if (!isNaN(page) && page >= 1 && page <= pagination?.totalPages) {
         handlePageChange(page);
      }
      setIsEditingPage(false);
      setPageInputValue('');
   };

   const handlePageInputBlur = () => {
      handlePageInputSubmit();
   };

   const handlePageKeyDown = (e) => {
      if (e.key === 'Enter') {
         handlePageInputSubmit();
      } else if (e.key === 'Escape') {
         setIsEditingPage(false);
         setPageInputValue('');
      }
   };

   const handlePageSizeChange = (e) => {
      const value = e.target.value;

      // If "ALL" is selected, set limit to null or totalProducts to fetch everything
      const newLimit = value === 'ALL' ? pagination?.totalProducts : Number(value);

      setLimit(newLimit);
      setCurrentPage(1); // Reset to page 1 to avoid offset issues
   };

   const handleDelete = async () => {
      if (selectedRowId !== null) {
         try {
            await dispatch(deleteVendor(selectedRowId, companyId));
            setData(data?.filter((row) => row.id !== selectedRowId));
            setDeleteDialogOpen(false); // Close the dialog after deletion
            await dispatch(
               getAccountForMaster({
                  type: 'E',
                  page: currentPage,
                  search: debouncedSearchQuery,
                  sortBy: sorting.length ? sorting[0]?.name : 'name',
                  sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'asc',
                  compId: user?.loginhistory?.companyId,
                  ...(shouldShowCompanyDropdown && { companyIds: user?.loginhistory?.companyId }),
               }),
            );
         } catch (err) {
            // console.error('Failed to delete series:', err);
         }
      }
   };

   const handleDeleteClick = (id) => {
      setSelectedRowId(id);
      setDeleteDialogOpen(true);
   };

   const handleMutiDeleteClick = (ids) => {
      if (ids.length > 0) {
         const payload = {
            ids: ids.map(Number),
            compId: user?.loginhistory?.companyId.toString(),
         };
         dispatch(multiDeleteCustomer(JSON.stringify(payload)));
         setDeleteDialogOpen(false); // Close the dialog after deletion
         dispatch(
            getAccountForMaster({
               type: 'E',
               page: currentPage,
               // limit: limit === pagination?.totalProducts ? undefined : limit, // undefined fetches everything
               search: debouncedSearchQuery,
               sortBy: sorting.length ? sorting[0]?.name : 'name',
               sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'asc',
               compId: user?.loginhistory?.companyId,
               ...(shouldShowCompanyDropdown && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
         dispatch(
            getAccount({
               type: 'E',
               page: currentPage,
               sortBy: sorting.length ? sorting[0]?.name : 'name',
               sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'asc',
               compId: user?.loginhistory?.companyId,
               ...(shouldShowCompanyDropdown && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
      }
   };

   const handleFocus = (id) => setFocusedInput(id);
   const handleBlur = () => setFocusedInput(null);
   // const [columnVisibility, setColumnVisibility] = React.useState(
   //    columnsData.reduce((acc, column) => {
   //       acc[column.id] = true;
   //       return acc;
   //    }, {}),
   // );

   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
   const { isOpen, onOpen, onClose } = useDisclosure();
   const [isEditMode, setIsEditMode] = React.useState(false);

   const columns = columnsData
      .filter((column) => columnVisibility[column.id])
      .map((column) =>
         columnHelper.accessor(column.id, {
            id: column.id,
            header: () => (
               <Text justifyContent="space-between" align="center" fontSize={{ sm: '10px', lg: '12px' }}>
                  {column.header}
               </Text>
            ),
            cell: (info) => <Flex align="center">{info.getValue()}</Flex>,
         }),
      );

   const table = useReactTable({
      data,
      columns,
      state: { sorting },
      onSortingChange: setSorting,
      getCoreRowModel: getCoreRowModel(),
      getSortedRowModel: getSortedRowModel(),
   });

   const ColumnVisibilityModal = ({ isOpen, onClose, columnVisibility, setColumnVisibility, user }) => {
      const [localVisibility, setLocalVisibility] = useState(columnVisibility);
      const companyId = Number(localStorage.getItem('companyId'));

      // Get theme mode
      const { colorMode } = useColorMode();
      const isDark = colorMode === 'dark';

      // Fix: Reset local state when modal opens OR when columnVisibility changes
      useEffect(() => {
         setLocalVisibility(columnVisibility);
      }, [isOpen, columnVisibility]); // Added columnVisibility as dependency

      // Handle ESC key to close modal
      useEffect(() => {
         const handleEscKey = (event) => {
            if (event.key === 'Escape' && isOpen) {
               onClose();
            }
         };

         document.addEventListener('keydown', handleEscKey);

         return () => {
            document.removeEventListener('keydown', handleEscKey);
         };
      }, [isOpen, onClose]);

      const handleSave = async () => {
         try {
            const updatedViewJson = user.viewJson
               ? user.viewJson.map((item) =>
                    item.companyId === companyId ? { ...item, account: localVisibility } : item,
                 )
               : [{ companyId, account: localVisibility }];

            await dispatch(
               postColumnsHideShow({
                  userId: user?.id,
                  viewJson: updatedViewJson,
               }),
            );

            setColumnVisibility(localVisibility);
            onClose();
         } catch (error) {
            console.error('Error saving column settings:', error);
         }
      };

      // Conditional render check
      if (!isOpen) return null;

      return (
         <div className="fixed inset-0 z-[999] flex items-center justify-center p-4">
            {/* Overlay with blur */}
            <div
               className={`absolute inset-0 transition-colors duration-300 ${isDark ? 'bg-black/70' : 'bg-black/40'}`}
               onClick={onClose}
            />

            {/* Modal Content */}
            <div
               className={`relative w-full max-w-2xl transform transition-all duration-300 ${
                  isDark
                     ? 'bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900'
                     : 'bg-gradient-to-br from-white via-gray-50 to-white'
               } rounded-2xl shadow-2xl border ${
                  isDark ? 'border-slate-700/50' : 'border-gray-200/50'
               } overflow-hidden flex flex-col max-h-[80vh]`}>
               {/* Header - Fixed */}
               <div
                  className={`relative px-8 py-6 border-b flex-shrink-0 ${
                     isDark
                        ? 'border-slate-700/50 bg-gradient-to-r from-slate-800/50 to-slate-900/50'
                        : 'border-gray-200/50 bg-gradient-to-r from-gray-50/50 to-white/50'
                  }`}>
                  <h2 className={`text-2xl font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>Show/Hide Columns</h2>
                  <p className={`mt-1 text-sm ${isDark ? 'text-slate-400' : 'text-gray-600'}`}>
                     Customize which columns appear in your table
                  </p>
                  <button
                     onClick={onClose}
                     className={`absolute top-6 right-6 p-2 rounded-lg transition-all duration-200 ${
                        isDark
                           ? 'hover:bg-slate-700/50 text-slate-400 hover:text-white'
                           : 'hover:bg-gray-100 text-gray-500 hover:text-gray-900'
                     }`}>
                     <X className="w-5 h-5" />
                  </button>
               </div>

               {/* Body - Scrollable */}
               <div className="flex-1 overflow-y-auto px-8 py-6">
                  <div className="grid grid-cols-2 gap-4">
                     {Object.entries(localVisibility).map(([key, value]) => (
                        <div
                           key={key}
                           className={`group relative p-5 rounded-xl transition-all duration-300 border-2 ${
                              value
                                 ? isDark
                                    ? 'bg-gradient-to-br from-blue-900/20 to-indigo-900/20 border-blue-500/50 shadow-lg shadow-blue-500/10'
                                    : 'bg-gradient-to-br from-blue-50/50 to-indigo-50/50 border-blue-400/50 shadow-lg shadow-blue-200/30'
                                 : isDark
                                 ? 'bg-slate-800/30 border-slate-700/30 hover:border-slate-600/50'
                                 : 'bg-white/50 border-gray-300/30 hover:border-gray-400/50'
                           } cursor-pointer hover:scale-[1.02]`}
                           onClick={() => setLocalVisibility((prev) => ({ ...prev, [key]: !prev[key] }))}>
                           {/* Toggle Switch */}
                           <div className="flex items-center justify-between">
                              <label
                                 className={`font-semibold text-base cursor-pointer transition-colors duration-200 capitalize ${
                                    isDark ? 'text-white' : 'text-gray-900'
                                 }`}>
                                 {key
                                    .split(/(?=[A-Z])/)
                                    .join(' ')
                                    .toLowerCase()}
                              </label>

                              <div
                                 className={`relative inline-flex h-7 w-12 items-center rounded-full transition-all duration-300 ${
                                    value
                                       ? isDark
                                          ? 'bg-gradient-to-r from-blue-600 to-indigo-600 shadow-lg shadow-blue-500/30'
                                          : 'bg-gradient-to-r from-blue-500 to-indigo-500 shadow-lg shadow-blue-400/30'
                                       : isDark
                                       ? 'bg-slate-700'
                                       : 'bg-gray-300'
                                 }`}>
                                 <span
                                    className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform duration-300 shadow-md ${
                                       value ? 'translate-x-6' : 'translate-x-1'
                                    }`}
                                 />
                              </div>
                           </div>

                           {/* Status indicator */}
                           <div
                              className={`mt-3 flex items-center gap-2 text-xs font-medium ${
                                 value
                                    ? isDark
                                       ? 'text-blue-400'
                                       : 'text-blue-600'
                                    : isDark
                                    ? 'text-slate-500'
                                    : 'text-gray-500'
                              }`}>
                              <div
                                 className={`h-1.5 w-1.5 rounded-full ${
                                    value
                                       ? isDark
                                          ? 'bg-blue-400 shadow-lg shadow-blue-400/50'
                                          : 'bg-blue-500 shadow-lg shadow-blue-400/50'
                                       : isDark
                                       ? 'bg-slate-600'
                                       : 'bg-gray-400'
                                 }`}
                              />
                              {value ? 'Visible' : 'Hidden'}
                           </div>
                        </div>
                     ))}
                  </div>
               </div>

               {/* Footer - Fixed */}
               <div
                  className={`px-8 py-5 border-t flex justify-end gap-3 flex-shrink-0 ${
                     isDark
                        ? 'border-slate-700/50 bg-gradient-to-r from-slate-800/50 to-slate-900/50'
                        : 'border-gray-200/50 bg-gradient-to-r from-gray-50/50 to-white/50'
                  }`}>
                  <button
                     onClick={onClose}
                     className={`px-6 py-2.5 rounded-lg font-semibold transition-all duration-200 border ${
                        isDark
                           ? 'border-slate-600 text-slate-300 hover:bg-slate-700/50 hover:text-white hover:border-slate-500'
                           : 'border-gray-300 text-gray-700 hover:bg-gray-100 hover:text-gray-900 hover:border-gray-400'
                     }`}>
                     Cancel
                  </button>
                  <button
                     onClick={handleSave}
                     className={`px-6 py-2.5 rounded-lg font-semibold transition-all duration-200 shadow-lg ${
                        isDark
                           ? 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-500 hover:to-indigo-500 text-white shadow-blue-500/30'
                           : 'bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 text-white shadow-blue-400/30'
                     }`}>
                     Save
                  </button>
               </div>
            </div>
         </div>
      );
   };

   // const handleSave = () => {
   //   if (isEditMode && currentRow) {
   //     setData(data.map((row) => (row.id === currentRow.id ? currentRow : row)));
   //   } else if (!isEditMode) {
   //     setData([...data, { ...currentRow, id: Date.now() }]);
   //   }
   //   onClose();
   // };
   const handleSave = async (data) => {
      // if (isEditMode) {
      //    await dispatch(updateAccount(data)); // If editing, dispatch update action
      //    // await dispatch(getVendors({ type: ACCOUNT_TYPE.VENDOR }));
      // } else {
      //    await dispatch(addVendor(data)); // If adding, dispatch add action
      //    // await dispatch(getVendors({ type: ACCOUNT_TYPE.VENDOR }));
      // }
      // onClose();
      dispatch(
         getAccountForMaster({
            type: 'E',
            page: currentPage,
            // limit: limit === pagination?.totalProducts ? undefined : limit, // undefined fetches everything
            search: debouncedSearchQuery,
            sortBy: sorting.length ? sorting[0]?.name : 'name',
            sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'asc',
            compId: user?.loginhistory?.companyId,
            ...(shouldShowCompanyDropdown && { companyIds: user?.loginhistory?.companyId }),
         }),
      );
      dispatch(
         getAccount({
            type: 'E',
            page: currentPage,
            sortBy: sorting.length ? sorting[0]?.name : 'name',
            sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'asc',
            compId: user?.loginhistory?.companyId,
            ...(shouldShowCompanyDropdown && { companyIds: user?.loginhistory?.companyId }),
         }),
      );
   };

   const handleRefreshData = () => {
      dispatch(
         getVendors({
            compId: user?.loginhistory?.companyId,
            type: ACCOUNT_TYPE.VENDOR,
            sortBy: 'name',
            sortOrder: 'desc',
         }),
      );
   };

   const handleStatusUpdate = async (id, status) => {
      try {
         await dispatch(updateStatus({ id, status })); // Update the status in the database
         // dispatch(getAccount({ type: ACCOUNT_TYPE.VENDOR })); // Refresh the data
      } catch (err) {
         console.error('Error updating status:', err);
      }
   };

   var dynamicArray = [];
   dynamicArray = [
      { label: 'Name', value: singleEntity?.name || '-' },
      { label: 'Email', value: singleEntity?.email || '-' },
      { label: 'Mobile', value: singleEntity?.mobile || '-' },
      { label: 'Address', value: singleEntity?.address1 || '-' },
      { label: 'GSTIN', value: singleEntity?.gst || '-' },
      { label: 'City', value: singleEntity?.city || '-' },
      { label: 'State', value: singleEntity?.state || '-' },
      { label: 'Country', value: singleEntity?.country || '-' },
      { label: 'Pincode', value: singleEntity?.pincode || '-' },
   ];
   const handleViewSingleData = async (id) => {
      const accountbyid = {
         id: Number(id), // id must be number
         compId: String(user?.loginhistory?.companyId), // compId must be string
      };
      const today = new Date().toISOString().split('T')[0];
      await dispatch(
         getReportOutstandingDetail({
            accIds: id,
            fromDate: '2010-04-01',
            toDate: today,
            companyIds: companyId,
            isPurchaseOs: 1,
         }),
      );
      await dispatch(getSingleVendors(id));
      if (accountbyid.id) {
         dispatch(
            getReportLedger({
               fromDate: '2010-04-01',
               toDate: today,
               companyIds: companyId.toString(),
               accIds: accountbyid.id.toString(),
            }),
         );
      }
      setIsOpenSingleView(true);
   };

   // --------------------- filter ---------------------
   const backgroundColor = useColorModeValue('white', 'rgba(12, 20, 41, 1)');

   const [selectedFilter, setSelectedFilter] = useState(''); // Stores selected filter type
   const [NameselectedFilter, setNameselectedFilter] = useState(''); // Stores input value
   const [MobileselectedFilter, setMobileselectedFilter] = useState('');
   const [PanselectedFilter, setPanselectedFilter] = useState('');
   const [EmailselectedFilter, setEmailselectedFilter] = useState('');
   const [gstselectedFilter, setgstselectedFilter] = useState('');
   const [createddateselectedFilter, setcreateddateselectedFilter] = useState('');
   const [AddressselectedFilter, setAddressselectedFilter] = useState('');
   const [CityselectedFilter, setCityselectedFilter] = useState('');
   const [stateselectedFilter, setstateselectedFilter] = useState('');
   const [CountryselectedFilter, setCountryselectedFilter] = useState('');
   const [PincodeselectedFilter, setPincodeselectedFilter] = useState('');
   const [ledgerselectedFilter, setledgerselectedFilter] = useState('');
   const [balanceselectedFilter, setbalanceselectedFilter] = useState('');

   const [inputValue, setInputValue] = useState('');
   const [NameInputValue, setNameInputValue] = useState(''); // Stores input value
   const [MobileInputValue, setMobileInputValue] = useState('');
   const [PanInputValue, setPanInputValue] = useState('');
   const [EmailInputValue, setEmailInputValue] = useState('');
   const [gstInputValue, setgstInputValue] = useState('');
   const [createddateInputValue, setcreateddateInputValue] = useState('');
   const [AddressInputValue, setAddressInputValue] = useState('');
   const [CityInputValue, setCityInputValue] = useState('');
   const [stateInputValue, setstateInputValue] = useState('');
   const [CountryInputValue, setCountryInputValue] = useState('');
   const [PincodeInputValue, setPincodeInputValue] = useState('');
   const [ledgerInputValue, setledgerInputValue] = useState('');
   const [balanceInputValue, setbalanceInputValue] = useState('');
   const [statusInputValue, setstatusInputValue] = useState('');
   const [addedName, setAddedName] = useState(''); // Stores final displayed value

   const [VendorsData, setVendorsData] = useState([]);

   useEffect(() => {
      const fetchData = async () => {
         try {
            // const fetchParams = selectedFilter === "option11" ? { type: 'K', name: NameInputValue } : { type: 'K' };

            let fetchParams = {
               compId: user?.loginhistory?.companyId,
               type: 'E',
               page: currentPage,
               // limit: limit === pagination?.totalProducts ? undefined : limit, // undefined fetches everything
               search: debouncedSearchQuery,
               sortBy: sorting.length ? sorting[0]?.name : 'name',
               sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'asc',
               ...(shouldShowCompanyDropdown && { companyIds: user?.loginhistory?.companyId }),
            }; // Default fetchParams
            let filters = []; // Array to hold filter objects

            // if (selectedFilter === 'option11') {
            if (NameInputValue && NameselectedFilter) {
               filters.push({ name: 'acc.name', value: NameInputValue, type: NameselectedFilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }
            if (MobileInputValue && MobileselectedFilter) {
               filters.push({ name: 'ac.mobile', value: MobileInputValue, type: MobileselectedFilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }
            if (PanInputValue && PanselectedFilter) {
               filter.push({ name: 'acc.pan', value: PanInputValue, type: PanselectedFilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }
            if (EmailInputValue && EmailselectedFilter) {
               filters.push({ name: 'ac.email', value: EmailInputValue, type: EmailselectedFilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }
            if (gstInputValue && gstselectedFilter) {
               filters.push({ name: 'ac.gst', value: gstInputValue, type: gstselectedFilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }
            if (createddateInputValue && createddateselectedFilter) {
               filters.push({ name: 'acc.createdAt', value: createddateInputValue, type: createddateselectedFilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }
            if (AddressInputValue && AddressselectedFilter) {
               filters.push({ name: 'ac.address1', value: AddressInputValue, type: AddressselectedFilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }
            if (CityInputValue && CityselectedFilter) {
               filters.push({ name: 'ci.name', value: CityInputValue, type: CityselectedFilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }
            if (stateInputValue && stateselectedFilter) {
               filters.push({ name: 'st.name', value: stateInputValue, type: stateselectedFilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }
            if (CountryInputValue && CountryselectedFilter) {
               filters.push({ name: 'co.name', value: CountryInputValue, type: CountryselectedFilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }
            if (PincodeInputValue && PincodeselectedFilter) {
               filters.push({ name: 'ac.pincode', value: PincodeInputValue, type: PincodeselectedFilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }
            if (ledgerInputValue && ledgerselectedFilter) {
               filters.push({ name: 'gl.name', value: ledgerInputValue, type: ledgerselectedFilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }
            if (balanceInputValue && balanceselectedFilter) {
               filters.push({ balance: { value: balanceInputValue, type: balanceselectedFilter } });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }

            // else if (selectedFilter === 'equal') {
            if (createddateInputValue) {
               fetchParams.country = createddateInputValue;
            }
            // }

            const response = await dispatch(getAccountForMaster(fetchParams));

            // const response = await dispatch(
            //     getAccount(selectedFilter === "option3" ? { type: 'K', name: inputValue } : { type: 'K' })
            // );

            // Check if response is an array
            if (response.length > 0) {
               setVendorsData(response);
            } else {
               console.warn('No data found. Setting empty array.');
               setVendorsData([]); // ✅ Prevents 'undefined' error
            }
         } catch (error) {
            console.error('Error fetching data:', error);
            setVendorsData([]); // ✅ Ensure an empty array is set
         }
      };
      if (user?.loginhistory?.companyId) {
         fetchData();
      }
   }, [
      dispatch,
      NameInputValue,
      gstInputValue,
      PanInputValue,
      CityInputValue,
      stateInputValue,
      CountryInputValue,
      PincodeInputValue,
      MobileInputValue,
      EmailInputValue,
      createddateInputValue,
      ledgerInputValue,
      balanceInputValue,
      user?.loginhistory?.companyId,
   ]);

   useEffect(() => {
      setData([...userData]);
   }, [userData]);

   const [isDropdownOpen, setDropdownOpen] = useState(false);

   const toggleDropdown = () => {
      setDropdownOpen(!isDropdownOpen);
   };

   const [selectedColumn, setSelectedColumn] = useState(null);

   const handleFilterClick = () => {
      const selectedKey = selectedColumn?.props?.children;

      const inputSetters = {
         NAME: setNameInputValue,
         ADDRESS: setAddressInputValue,
         CITY: setCityInputValue,
         STATE: setstateInputValue,
         COUNTRY: setCountryInputValue,
         PINCODE: setPincodeInputValue,
         MOBILE: setMobileInputValue,
         PAN: setPanInputValue,
         EMAIL: setEmailInputValue,
         GST: setgstInputValue,
         'CREATED DATE': setcreateddateInputValue,
         LEDGER: setledgerInputValue,
         BALANCE: setbalanceInputValue,
      };

      const selectedoption = {
         NAME: setNameselectedFilter,
         ADDRESS: setAddressselectedFilter,
         CITY: setCityselectedFilter,
         STATE: setstateselectedFilter,
         COUNTRY: setCountryselectedFilter,
         PINCODE: setPincodeselectedFilter,
         MOBILE: setMobileselectedFilter,
         PAN: setPanselectedFilter,
         EMAIL: setEmailselectedFilter,
         GST: setgstselectedFilter,
         'CREATED DATE': setcreateddateselectedFilter,
         LEDGER: setledgerselectedFilter,
         BALANCE: setbalanceselectedFilter,
      };

      if (selectedKey && inputSetters[selectedKey]) {
         inputSetters[selectedKey](inputValue); // Assign value only on button click
      }

      if (selectedKey && selectedoption[selectedKey]) {
         selectedoption[selectedKey](selectedFilter); // Assign value only on button click
      }

      setDropdownOpen(false);
   };

   const [inputValues, setInputValues] = useState({
      NAME: '',
      ADDRESS: '',
      CITY: '',
      STATE: '',
      COUNTRY: '',
      PINCODE: '',
      MOBILE: '',
      PAN: '',
      EMAIL: '',
      GST: '',
      'CREATED DATE': '',
      LEDGER: '',
      BALANCE: '',
   });

   // Function to update input values dynamically
   const handleInputChange = (column, value) => {
      setInputValues((prev) => ({
         ...prev,
         [column]: value,
      }));
   };

   const handlecancelClick = () => {
      if (selectedColumn?.props?.children === 'NAME') {
         setNameInputValue('');
      } else if (selectedColumn?.props?.children === 'MOBILE') {
         setMobileInputValue('');
      } else if (selectedColumn.props.children === 'PAN') {
         setPanInputValue('');
      } else if (selectedColumn.props.children === 'EMAIL') {
         setEmailInputValue('');
      } else if (selectedColumn.props.children === 'GST') {
         setgstInputValue('');
      } else if (selectedColumn.props.children === 'CREATED DATE') {
         setcreateddateInputValue('');
      } else if (selectedColumn.props.children === 'ADDRESS') {
         setAddressInputValue('');
      } else if (selectedColumn.props.children === 'CITY') {
         setCityInputValue('');
      } else if (selectedColumn.props.children === 'STATE') {
         setstatusInputValue('');
      } else if (selectedColumn.props.children === 'COUNTRY') {
         setCountryInputValue('');
      } else if (selectedColumn.props.children === 'PINCODE') {
         setPincodeInputValue('');
      } else if (selectedColumn.props.children === 'LEDGER') {
         setledgerInputValue('');
      } else if (selectedColumn.props.children === 'BALANCE') {
         setbalanceInputValue('');
      }
      // setSelectedFilter('');
      setDropdownOpen(false);
   };

   const getLeftValue = (column) => {
      switch (column) {
         case 'NAME':
         case 'PAN':
         case 'MOBILE':
            return '3%';
         case 'EMAIL':
         case 'GST':
            return '30%';
         case 'MOBILE':
            return '40%';
         case 'ADDRESS':
         case 'CITY':
         case 'CREATED DATE':
            return '60%';
         default:
            return '70%';
      }
   };

   const handleImageClick = (columnHeader) => {
      setSelectedColumn(columnHeader); // Store which column was clicked
      setDropdownOpen(true);
      const selectedKey = selectedColumn?.props?.children;
      const passinputvalue = {
         NAME: setNameInputValue,
         ADDRESS: setAddressInputValue,
         CITY: setCityInputValue,
         STATE: setstateInputValue,
         COUNTRY: setCountryInputValue,
         PINCODE: setPincodeInputValue,
         MOBILE: setMobileInputValue,
         PAN: setPanInputValue,
         EMAIL: setEmailInputValue,
         GST: setgstInputValue,
         'CREATED DATE': setcreateddateInputValue,
         LEDGER: setledgerInputValue,
         BALANCE: setbalanceInputValue,
      };

      if (selectedKey && passinputvalue[selectedKey]) {
         setInputValue(passinputvalue[selectedKey](inputValue)); // Assign value only on button click
      }

      if (selectedColumn?.props?.children === 'NAME') {
         setInputValue(NameInputValue);
      } else if (selectedColumn?.props?.children === 'MOBILE') {
         setInputValue(MobileInputValue);
      } else if (selectedColumn?.props?.children === 'PAN') {
         setInputValue(PanInputValue);
      } else if (selectedColumn?.props?.children === 'EMAIL') {
         setInputValue(EmailInputValue);
      } else if (selectedColumn?.props?.children === 'GST') {
         setInputValue(gstInputValue);
      } else if (selectedColumn?.props?.children === 'CREATED DATE') {
         setInputValue(createddateInputValue);
      } else if (selectedColumn?.props?.children === 'ADDRESS') {
         setInputValue(AddressInputValue);
      } else if (selectedColumn?.props?.children === 'CITY') {
         setInputValue(CityInputValue);
      } else if (selectedColumn?.props?.children === 'STATE') {
         setInputValue(stateInputValue);
      } else if (selectedColumn?.props?.children === 'COUNTRY') {
         setInputValue(CountryInputValue);
      } else if (selectedColumn?.props?.children === 'PINCODE') {
         setInputValue(PincodeInputValue);
      } else if (selectedColumn?.props?.children === 'LEDGER') {
         setInputValue(ledgerInputValue);
      } else if (selectedColumn?.props?.children === 'BALANCE') {
         setInputValue(balanceInputValue);
      }
      // setIsModalOpen(true); // Open modal
   };

   const glgroup = useSelector((state) => state.glGroup.list || []);
   const targetGlGroup = glgroup.find((group) => group.code === 'E');

   const [expanded, setExpanded] = useState(false);
   const wrapperRef = useRef();
   useOutsideClick({
      ref: wrapperRef,
      handler: () => {
         if (searchQuery === '') setExpanded(false);
      },
   });

   useEffect(() => {
      const handleKeyDown = (e) => {
         const activeElement = document.activeElement;
         const isTyping =
            activeElement?.tagName === 'INPUT' ||
            activeElement?.tagName === 'TEXTAREA' ||
            activeElement?.getAttribute('role') === 'textbox' ||
            activeElement?.isContentEditable;

         if (isTyping) return;

         if (e.key.toLowerCase() === 'n' || e.key === '+') {
            if (!isOpen && !isOpenSingleView && (Admin || vendorRight?.add)) {
               e.preventDefault();
               setCurrentRow({});
               setIsEditMode(false);
               onOpen();
            }
         }
      };

      window.addEventListener('keydown', handleKeyDown);

      return () => {
         window.removeEventListener('keydown', handleKeyDown);
      };
   }, [!isOpen, !isOpenSingleView, Admin, vendorRight?.add]);

   return (
      <>
         <Box bg={backgroundColor} w="100%">
            <Flex
               width={{ base: '100%', md: 'auto' }}
               px={{ base: '1px', md: '25px' }}
               justifyContent="space-between"
               align="center"
               overflowX="auto"
               flexWrap="nowrap"
               gap={3}>
               {/* Left Section: Title + Add Button */}
               <Flex align="center" gap={4} flexShrink={0}>
                  <Text
                     color={textColor}
                     ml={{ base: '8px', md: 0 }}
                     fontSize={{ base: '17px', lg: '22px' }}
                     fontWeight="700"
                     lineHeight="100%">
                     Vendor
                  </Text>
               </Flex>

               {/* Right Section: Pagination + Page Size + Search + Menu */}
               <Flex align="center" gap={2} flexShrink={0} p={3}>
                  {!isMobileOrTablet && (Admin || vendorRight?.add) && user && !user.isExpired && (
                     <button
                        onClick={() => {
                           setCurrentRow({});
                           setIsEditMode(false);
                           onOpen();
                        }}
                        className={`group relative flex items-center justify-center gap-3 py-2 px-7 rounded-xl font-medium shadow-lg transition-all duration-300 ease-out transform hover:-translate-y-1 focus:outline-none focus:ring-4 active:scale-95 overflow-hidden border ${
                           isDark
                              ? 'bg-gradient-to-br from-cyan-400 to-blue-500 hover:from-cyan-300 hover:to-blue-400 text-white shadow-cyan-500/30 hover:shadow-2xl hover:shadow-cyan-400/40 focus:ring-cyan-200/50 border-cyan-300/30'
                              : 'bg-gradient-to-br from-emerald-400 to-teal-500 hover:from-emerald-300 hover:to-teal-400 text-white shadow-emerald-500/30 hover:shadow-2xl hover:shadow-emerald-400/40 focus:ring-emerald-200/70 border-emerald-300/50'
                        }`}>
                        {/* Gradient overlay on hover */}
                        <span
                           className={`absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 transform translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-in-out ${
                              isDark ? 'via-cyan-100/20' : 'via-white/30'
                           }`}></span>

                        {/* Icon container with background */}
                        <span
                           className={`relative flex items-center justify-center w-6 h-6 rounded-lg backdrop-blur-sm transition-all duration-300 ${
                              isDark
                                 ? 'bg-cyan-100/20 group-hover:bg-cyan-100/30'
                                 : 'bg-white/20 group-hover:bg-white/30'
                           }`}>
                           <svg
                              className="w-4 h-4 transition-transform duration-300 group-hover:rotate-90"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 4v16m8-8H4" />
                           </svg>
                        </span>

                        <span className="relative text-base font-semibold">Add New</span>
                     </button>
                  )}

                  <IconButton
                     colorScheme="gray"
                     icon={<BsEye />}
                     size="md"
                     mr={1}
                     onClick={() => setIsColumnModalOpen(true)}
                  />

                  {/* Search Box */}
                  <MotionFlex
                     ref={wrapperRef}
                     align="center"
                     bg={bg}
                     borderRadius="full"
                     cursor="pointer"
                     px={expanded ? 3 : 0}
                     w={expanded ? '200px' : '40px'}
                     h="40px"
                     transition="all 0.3s ease"
                     onClick={() => setExpanded(true)}>
                     <MotionSearchIcon
                        color={icon}
                        animate={{ rotate: expanded ? 0 : 90 }}
                        transition={{ duration: 0.3 }}
                        style={{
                           marginRight: expanded ? '8px' : '10px',
                           marginLeft: expanded ? '0' : '10px',
                        }}
                     />
                     {expanded && (
                        <Input
                           variant="unstyled"
                           placeholder="Search..."
                           color={icon}
                           value={searchQuery}
                           onChange={handleSearchChange}
                           // onChange={(e) => setSearchQuery(e.target.value)}
                           autoFocus
                        />
                     )}
                  </MotionFlex>
               </Flex>

               {/* Mobile Fixed Add New Button */}
               {isMobileOrTablet && (Admin || vendorRight?.add) && user && !user.isExpired && (
                  <button
                     onClick={() => {
                        setCurrentRow({});
                        setIsEditMode(false);
                        onOpen();
                     }}
                     className={`group relative flex items-center justify-center gap-3 py-2 px-7 rounded-xl font-medium shadow-lg transition-all duration-300 ease-out transform hover:-translate-y-1 focus:outline-none focus:ring-4 active:scale-95 overflow-hidden border ${
                        isDark
                           ? 'bg-gradient-to-br from-cyan-400 to-blue-500 hover:from-cyan-300 hover:to-blue-400 text-white shadow-cyan-500/30 hover:shadow-2xl hover:shadow-cyan-400/40 focus:ring-cyan-200/50 border-cyan-300/30'
                           : 'bg-gradient-to-br from-emerald-400 to-teal-500 hover:from-emerald-300 hover:to-teal-400 text-white shadow-emerald-500/30 hover:shadow-2xl hover:shadow-emerald-400/40 focus:ring-emerald-200/70 border-emerald-300/50'
                     }`}>
                     {/* Gradient overlay on hover */}
                     <span
                        className={`absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 transform translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-in-out ${
                           isDark ? 'via-cyan-100/20' : 'via-white/30'
                        }`}></span>

                     {/* Icon container with background */}
                     <span
                        className={`relative flex items-center justify-center w-6 h-6 rounded-lg backdrop-blur-sm transition-all duration-300 ${
                           isDark ? 'bg-cyan-100/20 group-hover:bg-cyan-100/30' : 'bg-white/20 group-hover:bg-white/30'
                        }`}>
                        <svg
                           className="w-4 h-4 transition-transform duration-300 group-hover:rotate-90"
                           fill="none"
                           stroke="currentColor"
                           viewBox="0 0 24 24">
                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 4v16m8-8H4" />
                        </svg>
                     </span>

                     <span className="relative text-base font-semibold">Add New</span>
                  </button>
               )}
            </Flex>

            {isLoading ? (
               <Loader />
            ) : (
               <DynamicTable
                  right={vendorRight}
                  table={table}
                  data={sortedUserData.filter((a) => a.glGroupId === 12)}
                  handleViewSingleData={handleViewSingleData}
                  handleStatusChange={handleStatusUpdate}
                  handleImageClick={handleImageClick}
                  toggleDropdown={toggleDropdown}
                  filter={filter}
                  emptyMessage={'No vendor data found'}
                  onEditClick={(row) => {
                     setCurrentRow(row);
                     setIsEditMode(true);
                     onOpen();
                     setIsOpenSingleView(false);
                  }}
                  onDeleteClick={(id) => {
                     handleDeleteClick(id);
                     setIsOpenSingleView(false);
                  }}
                  onMultiDeleteClick={(ids) => {
                     handleMutiDeleteClick(ids);
                  }}
                  canDelete={true}
                  columnVisibility={columnVisibility}
                  columnsData={columnsData}
                  sorting={sorting}
                  limit={limit}
                  setCurrentRow={setCurrentRow}
                  onOpen={onOpen}
                  setIsEditMode={setIsEditMode}
                  setIsOpenSingleView={setIsOpenSingleView}
                  setDeleteDialogOpen={setDeleteDialogOpen}
                  setSelectedRowId={setSelectedRowId}
                  debouncedSearchQuery={debouncedSearchQuery}
               />
            )}

            {/* For Edit */}
            <AddEditForm
               isOpen={isOpen}
               onClose={onClose}
               isEditMode={isEditMode}
               currentRow={currentRow}
               initialData={currentRow}
               onSave={handleSave}
               parentGlGroup={targetGlGroup?.id}
               handleRefreshData={handleRefreshData}
               formType="Vendor"
               isAbs={isAbs}
            />

            <style jsx>{`
               .editable-row {
                  position: relative;
                  background: ${useColorModeValue('white', 'gray.700')};
                  transition: background 0.3s ease;
               }

               .editable-row:hover {
                  background: ${useColorModeValue('gray.100', 'gray.600')};
               }

               .editable-row .edit-icon-container {
                  display: none;
               }

               .editable-row:hover .edit-icon-container {
                  display: block;
                  position: absolute;
                  right: 10px;
                  top: 50%;
                  transform: translateY(-50%);
               }
            `}</style>
            <DeleteDialog
               isDeleteDialogOpen={isDeleteDialogOpen}
               setDeleteDialogOpen={setDeleteDialogOpen}
               handleDelete={handleDelete}
               title="Vendor"
            />
            <ViewSingleData
               singleEntityRights={vendorRight}
               isOpenSingleView={isOpenSingleView}
               onClose={() => setIsOpenSingleView(false)}
               entityType="vendor"
               singleEntity={singleEntityWithLedger}
               dynamicArray={dynamicArray}
               parentGlGroup={targetGlGroup?.id}
               formType="Vendor"
               reCall={(id) => handleViewSingleData(id)}
            />
         </Box>
         {isDropdownOpen && selectedColumn?.props?.children && (
            <Box
               position="absolute"
               // position="relative"
               top="300px" // Dropdown below image
               left={getLeftValue(selectedColumn?.props?.children)}
               width="auto"
               bg={backgroundColor}
               border="1px solid gray"
               borderRadius="5px"
               boxShadow="md"
               p="2"
               mt="2"
               zIndex="10"
               transition="all 0.2s ease-in-out">
               <Grid templateColumns="repeat(1, 1fr)" gap={4} p={4}>
                  <Grid justifyContent="center" color={textColor} fontSize="2xl" fontWeight="medium">
                     <label>
                        Select {selectedColumn.props.children.toLowerCase()}
                        {''}
                        Filter
                     </label>
                  </Grid>
                  <hr></hr>
                  {/* Label and Dropdown */}
                  {['CREATED DATE', 'BALANCE', 'GST PERCENTAGE', 'HSN', 'ORDINAL', 'ACCOUNT NO'].includes(
                     selectedColumn?.props?.children,
                  ) ? (
                     <GridItem display="flex" alignItems="center">
                        <FormLabel htmlFor="dropdown" width="60%" color={textColor}>
                           Select option
                        </FormLabel>
                        <Select
                           id="dropdown"
                           placeholder="Choose an option"
                           color={textColor}
                           onChange={(e) => setSelectedFilter(e.target.value)} // Update selected filter
                        >
                           <option value="equal">Equal (=)</option>
                           <option value="less_than">Less than (&lt;)</option>
                           <option value="less_than_equal">Less than or equal (&le;)</option>
                           <option value="greater_than">Greater than (&gt;)</option>
                           <option value="greater_than_equal">Greater than or equal (&le;)</option>
                        </Select>
                     </GridItem>
                  ) : (
                     <GridItem display="flex" alignItems="center">
                        <FormLabel htmlFor="dropdown" width="60%" color={textColor}>
                           Select option
                        </FormLabel>
                        <Select
                           id="dropdown"
                           placeholder="Choose an option"
                           color={textColor}
                           onChange={(e) => setSelectedFilter(e.target.value)} // Update selected filter
                        >
                           <option value="1">Starts With</option>
                           <option value="2">Ends With</option>
                           <option value="3">Contains</option>
                           <option value="4">Equal</option>
                           <option value="5">Empty</option>
                           <option value="6">Does Not Start With</option>
                           <option value="7">Does Not End With</option>
                           <option value="8">Does Not Contain</option>
                           <option value="9">Not Equal</option>
                           <option value="10">Not Empty</option>
                           <option value="11">Like</option>
                        </Select>
                     </GridItem>
                  )}

                  {/* Second Label and Input Box */}
                  {['CREATED DATE', 'BALANCE'].includes(selectedColumn?.props?.children) ? (
                     <GridItem display="flex" alignItems="center">
                        <FormLabel htmlFor="input1" width="60%" color={textColor}>
                           Select Date
                        </FormLabel>
                        <Input
                           type="date"
                           border="1px solid"
                           value={createddateInputValue}
                           onChange={(e) => setcreateddateInputValue(e.target.value)}
                        />
                     </GridItem>
                  ) : (
                     <GridItem display="flex" alignItems="center">
                        <FormLabel htmlFor="input1" width="60%" color={textColor}>
                           Enter the value
                        </FormLabel>
                        <Input
                           id="input2"
                           color={textColor}
                           placeholder="enter value"
                           value={inputValue}
                           onChange={(e) => setInputValue(e.target.value)}
                        />
                     </GridItem>
                  )}

                  {/* Button */}
                  <GridItem mt="20px" display="flex" justifyContent="space-between">
                     <Button colorScheme="blue" width="45%" onClick={handleFilterClick}>
                        Filter
                     </Button>
                     <Button colorScheme="red" width="45%" onClick={handlecancelClick}>
                        cancel
                     </Button>
                  </GridItem>
               </Grid>
            </Box>
         )}

         <ColumnVisibilityModal
            isOpen={isColumnModalOpen}
            onClose={() => setIsColumnModalOpen(false)}
            columnVisibility={columnVisibility}
            setColumnVisibility={setColumnVisibility}
            user={user}
         />
      </>
   );
}
